/**
 * Carousel JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Carousel
 */
class Carousel {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.carousel        = $( '#js-carousel' );
        this.stopCarousel    = $( '#js-stop-carousel' );
        this.carouselIframes =  this.carousel.find( 'iframe' );

        // Controller for aria live
        this.ariaLive = $( '#js-aria-live' );

        // Strings for screenreaders
        this.nextAdString     = themeData.themeStrings.ads.next_advertisement;
        this.previousAdString = themeData.themeStrings.ads.previous_advertisement;
        this.videoAdString    = themeData.themeStrings.ads.video_advertisement;
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Stop the carousel autoplay when the stop button is clicked
        this.stopCarousel.on( 'click', ( e ) => {
            $( '#js-carousel' ).slick( 'slickPause' );
        });


        // Get the current slide - if it has an embed video, allow it to be focused
        this.carousel.on( 'afterChange', ( e, slick, currentSlide ) => {

            // Get the active slide
            const activeSlide = $( slick.$slides[currentSlide]);

            // Get the current slide to check if its one with an embedded video
            const iframeSlide = activeSlide.find( 'iframe' );

            // If it is a video, focus on that
            if ( iframeSlide.length > 0 ) {
                iframeSlide.attr( 'tabindex', '0' );
            } else {

                // If not video, remove tabindex from iframe divs
                this.carousel.find( 'iframe' ).attr( 'tabindex', '-1' );
            }

        });

        // Stop the carousel when navigating with buttons. Can't cache the buttons because they are built here.
        $( '#js-carousel' ).find( 'button' ).on( 'click', ( e ) => {

            $( '#js-carousel' ).slick( 'slickPause' );

            // After changing an ad with the buttons, use aria-live accordingly
            this.carousel.on( 'afterChange', ( e, slick, currentSlide ) => {

                // Get the current slide and its image
                const activeSlide = $( slick.$slides[currentSlide]);
                const currentImage = activeSlide.find( 'img' );

                let currentAriaText = '';

                // If its an image, get the alt text, and if not, set aria live to notify the user that we are watching a video ad
                if ( currentImage.length ) {
                    currentAriaText = currentImage.attr( 'alt' );
                } else {
                    currentAriaText = this.videoAdString;
                }

                // Update the aria live component
                this.ariaLive.html( currentAriaText );

            });

        });
    }

    /**
     * Set titles for iframes on load
     */
    titlesForIframes() {
        this.carouselIframes.each( ( e, iframe ) => {
            const iframeTitle = $( iframe ).parent( '.carousel__item-wrap__item' ).attr( 'srtitle' );
            $( iframe ).attr( 'title', iframeTitle );
        });
    }

    /**
     * Build carousels from wrappers containing the id js-carousel.
     */
    buildCarousels() {
        this.carousel.slick({
            centerMode: true,
            centerPadding: '10rem',
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnFocus: true,
            pauseOnHover: true,
            infinite: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-arrow-left" aria-hidden="true"></i><span class="sr-only">' + this.previousAdString + '</span></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fas fa-arrow-right" aria-hidden="true"></i><span class="sr-only">' + this.nextAdString + '</span></button>',
            responsive: [
                {
                  breakpoint: 640,
                  settings: {
                    arrows: true,
                    centerMode: false,
                    centerPadding: '3rem',
                    slidesToShow: 1
                  }
                }
              ]
        });

        // Change the iframes so that you can't scroll through them tabbing. This is changed in events if the
        // current ad is a video
        this.carousel.find( 'iframe' ).attr( 'tabindex', '-1' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.buildCarousels();
        this.events();
        this.titlesForIframes();
    }
}

// Export the class reference.
module.exports = Carousel;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/carousel.js